import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
var BoundaryNodeRule = /*#__PURE__*/function () {
  function BoundaryNodeRule() {
    _classCallCheck(this, BoundaryNodeRule);
  }
  _createClass(BoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {}
  }]);
  return BoundaryNodeRule;
}();
export { BoundaryNodeRule as default };
var Mod2BoundaryNodeRule = /*#__PURE__*/function () {
  function Mod2BoundaryNodeRule() {
    _classCallCheck(this, Mod2BoundaryNodeRule);
  }
  _createClass(Mod2BoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount % 2 === 1;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
  return Mod2BoundaryNodeRule;
}();
var EndPointBoundaryNodeRule = /*#__PURE__*/function () {
  function EndPointBoundaryNodeRule() {
    _classCallCheck(this, EndPointBoundaryNodeRule);
  }
  _createClass(EndPointBoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount > 0;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
  return EndPointBoundaryNodeRule;
}();
var MultiValentEndPointBoundaryNodeRule = /*#__PURE__*/function () {
  function MultiValentEndPointBoundaryNodeRule() {
    _classCallCheck(this, MultiValentEndPointBoundaryNodeRule);
  }
  _createClass(MultiValentEndPointBoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount > 1;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
  return MultiValentEndPointBoundaryNodeRule;
}();
var MonoValentEndPointBoundaryNodeRule = /*#__PURE__*/function () {
  function MonoValentEndPointBoundaryNodeRule() {
    _classCallCheck(this, MonoValentEndPointBoundaryNodeRule);
  }
  _createClass(MonoValentEndPointBoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount === 1;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
  return MonoValentEndPointBoundaryNodeRule;
}();
BoundaryNodeRule.Mod2BoundaryNodeRule = Mod2BoundaryNodeRule;
BoundaryNodeRule.EndPointBoundaryNodeRule = EndPointBoundaryNodeRule;
BoundaryNodeRule.MultiValentEndPointBoundaryNodeRule = MultiValentEndPointBoundaryNodeRule;
BoundaryNodeRule.MonoValentEndPointBoundaryNodeRule = MonoValentEndPointBoundaryNodeRule;
BoundaryNodeRule.MOD2_BOUNDARY_RULE = new Mod2BoundaryNodeRule();
BoundaryNodeRule.ENDPOINT_BOUNDARY_RULE = new EndPointBoundaryNodeRule();
BoundaryNodeRule.MULTIVALENT_ENDPOINT_BOUNDARY_RULE = new MultiValentEndPointBoundaryNodeRule();
BoundaryNodeRule.MONOVALENT_ENDPOINT_BOUNDARY_RULE = new MonoValentEndPointBoundaryNodeRule();
BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE = BoundaryNodeRule.MOD2_BOUNDARY_RULE;